import { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import avatar from "../../assets/avatar.png";
import { useParams } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";

const ThreeDotLoader = () => (
  <div className="flex justify-center items-center space-x-2 h-20">
    <div className="w-3 h-3 rounded-full animate-bounce bg-gray-400"></div>
    <div className="w-3 h-3 rounded-full animate-bounce bg-[#2f064e]"></div>
    <div className="w-3 h-3 rounded-full animate-bounce bg-black"></div>
  </div>
);


export default function ProfileCard() {
  const [activeTab, setActiveTab] = useState("User Details");
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [tabContent, setTabContent] = useState({});
  const [userData, setUserData] = useState()

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const token = Cookies.get("session");
      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/user/getUserById`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );

      const user = response.data.userDetails;
      console.log("userer", response.data)
      const walletBalance = user?.Wallet?.balance || 0;
      setUserData(response.data.user)
      const dynamicTabs = {
        "User Details": {
          "User ID": user.userId || "N/A",
          Name: user.fullname || "N/A",
          Email: user.email || "N/A",
          "Company Name": user.company || "N/A",
          "Phone Number": user.phoneNumber || "N/A",
          "Registration Date": new Date(user.createdAt).toLocaleDateString(),
          "Account Status": user.isVerified ? "Active" : "Inactive",
          "KYC Status": user.kycStatus ? "Verified" : "Pending",
          "Wallet Balance": `₹${user.walletAmount}`,
          "Credit Limit": `₹${user.creditLimit || 0}`,
          "Rate Card": user.rateCard || "N/A",
          "Early Code": user.codPlan || "N/A",
        },
        "KYC Details": {
          // "KYC Type": "Aadhaar",
          "Verification Method": "Online",
          "KYC Level": user.kycDone ? "Full" : "None",
          "KYC Status": user.kycStatus ? "Verified" : "Pending",
          "Verification Date": user.kycStatus ? new Date(user.updatedAt).toLocaleDateString() : "N/A",
        },
        "Aadhar Details": {
          Name: user?.aadharDetails?.nameOnAadhar || "N/A",
          "Aadhaar Number": user?.aadharDetails?.aadharNumber || "N/A",
          State: user?.aadharDetails?.state || "N/A",
          Address: user?.aadharDetails?.address || "N/A",
        },
        "Bank Details": {
          "Beneficiary Name": user?.accountDetails?.beneficiaryName || "N/A",
          "Bank Number": user?.accountDetails?.accountNumber || "N/A",
          "Account Name": user?.accountDetails?.bankName || "N/A",
          IFSC: user?.accountDetails?.ifscCode || "N/A",
          Branch: user?.accountDetails?.branchName || "N/A",
        },
        "PAN Details": {
          "PAN Number": user?.panDetails?.panNumber || "N/A",
          Name: user?.panDetails?.nameOnPan || "N/A",
          Type: user?.panDetails?.panType || "N/A",
          "PAN Ref ID": user?.panDetails?.referenceId || "N/A",
        },
        "GST Details": {
          "GST Number": user?.gstDetails?.gstNumber || "N/A",
          "Company Name": user?.company || "N/A",
          "Company Address": user?.gstDetails?.companyAddress || "N/A",
          Pincode: user?.gstDetails?.pincode || "N/A",
          City: user?.gstDetails?.city || "N/A",
          State: user?.gstDetails?.state || "N/A",
        },
      };

      setTabContent(dynamicTabs);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="flex flex-col sm:flex-row items-start justify-start sm:p-2 p-1 gap-6">
      {/* Left Side: Profile Card */}
      <div className="rounded-lg bg-white shadow-lg p-5 w-full sm:max-w-xs text-left">
        <div className="flex items-center gap-4">
          <img
            src={avatar}
            alt="User Avatar"
            className="w-[70px] h-[70px] rounded-full border-2 border-gray-300"
          />
          <div>
            <div className="flex items-center gap-2">
              <h2 className="text-[14px] font-[600] whitespace-nowrap text-gray-700">
                {tabContent["User Details"]?.Name || "User Name"}
              </h2>
            </div>
            <p className="text-gray-500 text-sm">
              User ID: {tabContent["User Details"]?.["User ID"] || "N/A"}
            </p>
          </div>
        </div>

        <div className="mt-6 space-y-3 text-[12px] font-[600] text-gray-700">
          {Object.keys(tabContent).map((label) => (
            <div
              key={label}
              className={`flex justify-between items-center border-b pb-2 cursor-pointer hover:text-gray-700 transition-all duration-200 ease-in-out ${activeTab === label ? "font-[600]" : "text-gray-500"
                }`}
              onClick={() => setActiveTab(label)}
            >
              <p>{label}</p>
              <ChevronRight size={16} />
            </div>
          ))}
        </div>
      </div>

      {/* Right Side: Tab Content Section */}
      <div className="bg-white rounded-lg shadow-lg p-5 w-full sm:max-w-6xl">
        {/* Tabs (visible only on desktop) */}
        <div className="border-b flex-wrap gap-2 sm:gap-4 text-[12px] text-gray-700 hidden sm:flex">
          {Object.keys(tabContent).map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`relative p-2 ${activeTab === tab
                ? "border-b-2 rounded-tl-lg rounded-tr-lg text-white bg-[#0CBB7D] border-[#0CBB7D] font-[600] px-2 py-1"
                : "hover:bg-green-100 rounded-tl-lg rounded-tr-lg text-gray-500 font-[600] px-2 py-1"
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        {loading ? (
          <ThreeDotLoader />
        ) : tabContent[activeTab] ? (
          <div className="mt-4 text-gray-700 text-[12px] p-2 rounded-lg grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-4">
            {Object.entries(tabContent[activeTab]).map(([label, value]) => (
              <div key={label} className="flex flex-col">
                <span className="text-gray-500 font-[600] text-[14px]">{label}:</span>
                <span className="text-gray-500 font-[400] text-[12px]">{value}</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-red-500 mt-4">No data available.</p>
        )}
      </div>
    </div>
  );
}
